import auth from './auth/store';
import batch from './batch/store';
import compliance from './compliance/store';
import credits from './credits/store';
import dashboard from './dashboard/store';
import history from './history/store';
import invite from './invite/store';
import metrics from './metrics/store';
import recurrent from './recurrent/store';
import status from './status/store';
import support from './support/store';
import template from './template/store';

const stores = {
  auth,
  dashboard,
  compliance,
  template,
  history,
  credits,
  metrics,
  support,
  batch,
  invite,
  recurrent,
  status,
};

export default stores;
